<studio-ui-section
    *ngIf="images$ | async as elements"
    class="no-padding"
    headline="Image">
    <div class="setting">
        <asset-property
            [context]="AssetPropertyContext.Replace"
            [showReplaceButton]="true"
            label="Content"
            [allowFeed]="true"
            [allowRemove]="false"
            [elements]="elements"
            (feedSettingsChanged)="onFeedSettingsChanged($event)"></asset-property>
        <fit-options
            *ngIf="isSizeModeEnabled"
            [sizeMode]="sizeMode"
            (sizeModeChanged)="updateImageSizeMode($event)"></fit-options>
    </div>

    <div
        *ngIf="isImageOptimizationEnabled"
        class="body divider">
        <image-optimization
            [elements]="elements"
            (highDpiChange)="updateHighDPI($event)"
            (qualityChange)="updateQuality($event)"></image-optimization>
    </div>
</studio-ui-section>
